module.exports = __webpack_public_path__ + "static/media/head-side-medical.963fed78.svg";